import { type ReactElement } from 'react';
import SolutionPageLayout from '../../components/features/SolutionPageLayout';

export default function Freelancer(): ReactElement {
  return (
    <SolutionPageLayout
      badge="Für Freelancer"
      title="Buchhaltung für Freelancer – einfach und zeitsparend"
      subtitle="Als Freelancer haben Sie genug zu tun. Saldify nimmt Ihnen die Buchhaltung ab, damit Sie sich auf das konzentrieren können, was Sie am besten können."
      heroImage="/screenshots/app-dashboard.webp"
      heroImageAlt="Saldify-Dashboard mit Umsatz und offenen Forderungen"
      introTitle="Mehr Zeit für Ihre Projekte"
      introText="Als Freelancer jonglieren Sie täglich zwischen Kundenaufträgen, Akquise und Administration. Mit Saldify erledigen Sie Ihre Buchhaltung nebenbei – in wenigen Minuten pro Woche statt Stunden."
      introBullets={[
        'Rechnungen in unter 2 Minuten erstellen',
        'Belege per App fotografieren und fertig',
        'Automatische Vorbereitung für die Steuererklärung',
        'Überblick über offene Zahlungen und Liquidität',
      ]}
      benefits={[
        {
          title: 'Professionelle Rechnungen',
          description: 'Erstellen Sie Rechnungen, die Eindruck machen – mit Ihrem Logo und Corporate Design.',
        },
        {
          title: 'Zeit sparen',
          description: 'Automatische Belegerkennung und Kategorisierung reduzieren manuelle Arbeit auf ein Minimum.',
        },
        {
          title: 'Steuern im Griff',
          description: 'Umsatzsteuer-Übersicht und EÜR-Vorbereitung – Sie sind immer auf dem aktuellen Stand.',
        },
        {
          title: 'Mobil arbeiten',
          description: 'Erfassen Sie Belege unterwegs und behalten Sie Ihre Finanzen auch mobil im Blick.',
        },
        {
          title: 'Kein Vorwissen nötig',
          description: 'Saldify führt Sie Schritt für Schritt durch die Buchhaltung – ohne Fachchinesisch.',
        },
        {
          title: 'Bezahlbar',
          description: 'Starten Sie kostenlos und zahlen Sie nur, was Sie wirklich brauchen.',
        },
      ]}
      useCases={[
        {
          title: 'Designer & Kreative',
          description: 'Projektbasierte Rechnungen, Zeiterfassung und Angebote für kreative Freelancer.',
        },
        {
          title: 'IT & Entwickler',
          description: 'Stundenabrechnungen, Vertragsvorlagen und automatische Rechnungsstellung.',
        },
        {
          title: 'Berater & Coaches',
          description: 'Honorarabrechnungen, Reisekosten erfassen und Kunden verwalten.',
        },
        {
          title: 'Texter & Journalisten',
          description: 'Artikel abrechnen, Pauschalen verwalten und den Überblick behalten.',
        },
      ]}
      features={[
        'Unbegrenzte Rechnungen und Angebote',
        'Belegerfassung per App',
        'EÜR-Auswertung für die Steuererklärung',
        'Kundenverwaltung mit Kontakthistorie',
        'Zahlungserinnerungen automatisch versenden',
        'Umsatzsteuer-Übersicht',
        'Export für den Steuerberater',
        'DSGVO-konform und sicher',
      ]}
      recommendedPlan={{
        name: 'Plus',
        price: '9€/Monat',
        description: 'Ideal für Freelancer: 30 Rechnungen, 100 Belege, EÜR-Auswertung und Mobile App inklusive.',
      }}
      testimonial={{
        quote: 'Seit ich Saldify nutze, brauche ich für meine Buchhaltung nur noch 30 Minuten pro Monat. Früher war das ein ganzer Tag.',
        author: 'Lena M.',
        role: 'UX Designerin',
        company: 'Freelancerin seit 2019',
      }}
    />
  );
}
